import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PurchaseStateContextProvider } from "@/app/lib/context/PurchaseStateContext";
import { useFlightSearchTokens } from "@/app/lib/hooks/useFlightSearchTokens";
import { FlightFiltersProvider } from "@/app/lib/context/FlightFiltersContext";
import { SearchDataMissingErrorBoundary } from "@/app/lib/errors/SearchDataMissingErrorBoundary";
import { FlightSelectionPayloadProvider } from "@/app/lib/context/FlightSelectionPayloadContext/FlightSelectionPayloadContextProvider";

export const Route = createFileRoute("/_authenticated/_flights")({
  component: FlightsRoute,
});

function FlightsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  const { query } = useFlightSearchTokens();

  return (
    <FlightFiltersProvider defaultFilters={query.data?.defaultFilters || null}>
      <FlightSelectionPayloadProvider>
        <PurchaseStateContextProvider>
          <Outlet />
        </PurchaseStateContextProvider>
      </FlightSelectionPayloadProvider>
    </FlightFiltersProvider>
  );
}
